import { render, staticRenderFns } from "./imglist.vue?vue&type=template&id=3dd36522"
import script from "./imglist.vue?vue&type=script&lang=js"
export * from "./imglist.vue?vue&type=script&lang=js"
import style0 from "./imglist.vue?vue&type=style&index=0&id=3dd36522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports